/**
 * emailValidation.js — validatore email condiviso, più stringente del
 * classico `/@./` regex.
 *
 * Regole:
 *  - local@domain, entrambi non vuoti, senza spazi
 *  - domain deve contenere almeno un punto
 *  - TLD (ultima parte dopo l'ultimo `.`) deve essere 2-24 caratteri
 *    esclusivamente alfabetici (nessun numero, nessun trattino)
 *  - la virgola `,` non è ammessa da nessuna parte (blocca `mario,rossi@x,com`)
 *  - blocklist di TLD-typo più comuni (`.con`, `.cim`, `.vom`, `.itt`, ecc.)
 *  - blocca finali sospette tipo `.` finale, o `..` doppio dot
 */

const TLD_TYPO_BLOCKLIST = new Set([
  // Common typos of .com
  "con", "cin", "cim", "cpm", "coom", "com1", "conm", "comm", "cok", "vom",
  "xom", "cmo", "ocm", "comn",
  // Common typos of .it
  "itt", "iit", "ir1", "iy", "ig", "ti", "yt",
  // Common typos of .org / .net
  "orgg", "orh", "otg", "nrt", "nte", "nef",
  // Common typos of .eu
  "wu",
  // Numeric-only fake TLD
  "1", "0",
]);

const EMAIL_STRICT_REGEX = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,24}$/;

/**
 * @param {string} raw
 * @returns {{ ok: boolean, reason?: string }}
 */
export function checkEmail(raw) {
  const s = String(raw || "").trim();
  if (!s) return { ok: false, reason: "Email obbligatoria" };
  if (/\s/.test(s)) return { ok: false, reason: "L'email non può contenere spazi" };
  if (s.includes(",")) return { ok: false, reason: "L'email non può contenere virgole (probabile refuso: usa un punto)" };
  if (s.includes("..")) return { ok: false, reason: "L'email contiene due punti consecutivi" };
  if (!EMAIL_STRICT_REGEX.test(s)) {
    return { ok: false, reason: "Formato email non valido — deve essere nome@dominio.est (es. .com, .it)" };
  }
  // TLD-typo blocklist
  const tld = s.split(".").pop().toLowerCase();
  if (TLD_TYPO_BLOCKLIST.has(tld)) {
    return { ok: false, reason: `Estensione ".${tld}" non valida — forse intendevi ".com" o ".it"?` };
  }
  return { ok: true };
}

/** Legacy convenience — returns boolean only. */
export function isValidEmail(s) {
  return checkEmail(s).ok;
}
